import type { ReleasePage } from './releases.types'

/** The last copy of each release this tab read, so a reload shows it at once while the fleet answers.
 *  sessionStorage, so it ends with the tab; logout clears it too (auth.store.ts). */
const PREFIX = 'adx_release_last:'
/** A copy bigger than this is not kept: sessionStorage holds about 5 MB for the whole site. */
const MAX_CHARS = 1_500_000

export function readLastRelease(name: string): ReleasePage | null {
  try {
    const raw = sessionStorage.getItem(`${PREFIX}${name}`)
    return raw ? (JSON.parse(raw) as ReleasePage) : null
  } catch {
    return null
  }
}

export function writeLastRelease(page: ReleasePage): void {
  try {
    const raw = JSON.stringify(page)
    if (raw.length <= MAX_CHARS) sessionStorage.setItem(`${PREFIX}${page.version.name}`, raw)
  } catch {
    // A full or blocked sessionStorage only loses the instant reload.
  }
}

export function clearLastReleases(): void {
  try {
    const keys: string[] = []
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i)
      if (key?.startsWith(PREFIX)) keys.push(key)
    }
    for (const key of keys) sessionStorage.removeItem(key)
  } catch {
    // Nothing kept, nothing to clear.
  }
}
